/**
 * @description Generates a Promise with timeout resolution
 * @param {Promise<any>} promise
 * @param {number} timeout
 * @param {Error} timeOutError
 * @returns {Promise<any>}
 * @example
 * this.utils.Promise.promiseWithTimeout<YourPromiseType>( YourPromise, 1000, new Error( 'Custom message for timed out.' ) );
 */
export const promiseWithTimeout = <T>(
	promise: Promise<T>,
	timeout: number,
	timeOutError: Error = new Error( 'Promise timed out' )
): Promise<T> => {
	const timeOut = new Promise<never>( ( resolve, reject ) => {
		setTimeout( () => {
			reject( timeOutError );
		}, timeout );
	} );
	return Promise.race<T>( [ promise, timeOut ] );
};